import { Component, EventEmitter, Output } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-cdc-payment-modal',
    templateUrl: './cdc-payment-modal.component.html',
    styleUrl: 'cdc-payment-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class CdcPaymentModalComponent extends ModalComponent {
    public static readonly cannotBeOverriden: boolean = true;

    title: string = 'Rappel !';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_info_payment',
        categorieClic: 'Modale_info',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Finaliser_la_commande',
        categorieClic: 'Modale_info',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_info',
    };

    @Output() public validateEvent = new EventEmitter<boolean>();

    public modalRef: ModalService;

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    private onCloseHandler(): void {
        this.validateEvent.emit();
        this.modalRef.close();
    }
}
